import { useLayoutEffect, useRef, useState } from "react";

/** 旧 Vue ProTable 根据表格顶部位置限制表体高度，并给底部分页留出空间。 */
export function useViewportTableMaxHeight(enabled: boolean, refreshKey: unknown) {
    const hostRef = useRef<HTMLDivElement>(null);
    const [maxHeight, setMaxHeight] = useState<number>();

    useLayoutEffect(() => {
        const host = hostRef.current;
        if (!enabled || !host || !host.closest('.layout-main-container > section[aria-label$="-page"]:not([aria-label$="-detail-page"])')) {
            setMaxHeight(undefined);
            return;
        }

        /** 表头随筛选条件换行时，重新计算可视表体和分页可用的高度。 */
        const measure = () => {
            const table = host.querySelector<HTMLElement>(".zh-table");
            const layout = host.closest<HTMLElement>(".layout-main-container");
            if (!table || !layout) return;
            const availableBottom = Math.min(window.innerHeight, layout.getBoundingClientRect().bottom);
            const nextHeight = Math.max(160, Math.floor(availableBottom - table.getBoundingClientRect().top - 72));
            setMaxHeight(current => (current === nextHeight ? current : nextHeight));
        };

        measure();
        window.addEventListener("resize", measure);
        const header = host.querySelector<HTMLElement>(".zh-table__header");
        const observer = typeof ResizeObserver === "undefined" ? undefined : new ResizeObserver(measure);
        if (header) observer?.observe(header);
        return () => {
            window.removeEventListener("resize", measure);
            observer?.disconnect();
        };
    }, [enabled, refreshKey]);

    return { hostRef, maxHeight };
}
